import React, { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import { obtenerArchivos } from "../AccionesBackend";
import {VisualizadorPdfs} from "./VisualizadorPdfs";
import {BotonRegresar} from "../BotonRegresar";

export const SeNice = () => {
    const [flyers, setFlyers] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFlyers = async () => {
            try {
                const response = await obtenerArchivos({ seccionId: 3 });
                if (response && response.success) {
                    if (response.archivos && response.archivos.length > 0) {
                        const mappedFlyers = response.archivos.map(file => ({
                            src: file.ruta_archivo,
                            title: file.nombre_archivo,
                        }));
                        setFlyers(mappedFlyers);
                    } else {
                        setError("No se encontraron archivos.");
                    }
                } else {
                    setError("Error al obtener los archivos.");
                    console.error("No se pudieron obtener los archivos");
                }
            } catch (err) {
                setError("Error en la conexión o en el servidor.");
                console.error("Error al obtener los archivos:", err);
            }
        };

        fetchFlyers();
    }, []);

    return (
        <section className="flyers-digitales">
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1>Sé Nice</h1>
                </div>
                { error ? (
                    <p style={{ textAlign: "center", padding: "20px", color: "red" }}>{error}</p>
                ) : (
                    <VisualizadorPdfs initialPdfs={flyers} />
                )}
            </Container>
        </section>
    );
};
